module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component.css
// module id = ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component.css
// module chunks = main